import { render, staticRenderFns } from "./housemaid-policy-detail-info.vue?vue&type=template&id=18bc75e4&scoped=true&"
import script from "./housemaid-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./housemaid-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./housemaid-policy-detail-info.vue?vue&type=style&index=0&id=18bc75e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc75e4",
  null
  
)

export default component.exports